export const GET_MENUS_REQUESTED = 'GET_MENUS_REQUESTED'
export const GET_MENUS_SUCCEEDED = 'GET_MENUS_SUCCEEDED'
export const GET_MENUS_FAILED = 'GET_MENUS_FAILED'
